/** Xprinter vendor DLE commands (ESC/POS family). See iprtapp.com/psdk/command/esc/ */

const DLE = 0x10;
const DLE_FF = 0xff;

export const XPRINTER_AUTO_POWER_OFF_MAX_MINUTES = 120;

export function clampXprinterAutoPowerOffMinutes(minutes: number): number {
  if (!Number.isFinite(minutes)) return 0;
  return Math.min(XPRINTER_AUTO_POWER_OFF_MAX_MINUTES, Math.max(0, Math.floor(minutes)));
}

/** Wake a sleeping printer (8 null bytes). */
export function encodeXprinterWakeBytes(): Uint8Array {
  return new Uint8Array(8);
}

/** Set auto power-off time in minutes; 0 disables auto shutdown. */
export function encodeXprinterSetAutoPowerOffMinutes(minutes: number): Uint8Array {
  const m = clampXprinterAutoPowerOffMinutes(minutes);
  return new Uint8Array([DLE, DLE_FF, 0x10, 0x0a, m & 0xff, (m >> 8) & 0xff]);
}

/** Query current auto power-off time (minutes). */
export function encodeXprinterQueryAutoPowerOffMinutes(): Uint8Array {
  return new Uint8Array([DLE, DLE_FF, 0x10, 0x0b]);
}

/** Parse query response uint16 LE minutes when present. */
export function parseXprinterAutoPowerOffQueryResponse(bytes: Uint8Array): number | null {
  if (bytes.length < 2) return null;
  const low = bytes[bytes.length - 2] ?? 0;
  const high = bytes[bytes.length - 1] ?? 0;
  const minutes = low | (high << 8);
  if (!Number.isFinite(minutes) || minutes < 0 || minutes > 0xffff) return null;
  return clampXprinterAutoPowerOffMinutes(minutes);
}
